import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import {
    DefaultIntlFormatValues,
    EqualWidthMessageColumns,
    PRODUCT_CARD_HORIZONTAL_PADDING_PERCENTAGE,
} from '@ratehub/base-ui';

import getTextForChequingFeature from '../functions/getTextForChequingFeature';


function ChequingAccountFooter({
    transactions,
    accountType,
    eligibility,
    className,
}) {
    const intl = useIntl();

    return (
        <StyledEqualWidthMessageColumns
            className={className}
            columns={columnsFromChequingAccount({
                transactions,
                accountType,
                eligibility,
                intl,
            })}
        />
    );
}

ChequingAccountFooter.propTypes = {
    transactions: PropTypes.oneOfType([
        PropTypes.string,       // i.e. 'Unlimited'
        PropTypes.number,
    ]).isRequired,
    accountType: PropTypes.string.isRequired,
    eligibility: PropTypes.string,
    className: PropTypes.string,
};

const StyledEqualWidthMessageColumns = styled(EqualWidthMessageColumns)`
    padding-left: ${PRODUCT_CARD_HORIZONTAL_PADDING_PERCENTAGE};
    padding-right: ${PRODUCT_CARD_HORIZONTAL_PADDING_PERCENTAGE};
`;


function columnsFromChequingAccount({
    transactions,
    accountType,
    eligibility,
    intl,
}) {
    return [
        <FormattedMessage
            key="a1"
            id="web-components.chequing.footer.transactions"
            defaultMessage="Transactions: <strong>{transactions}</strong>"
            values={{
                transactions: getTextForChequingFeature({ intl, value: transactions }),
                ...DefaultIntlFormatValues,
            }}
        />,

        <FormattedMessage
            key="a2"
            id="web-components.chequing.footer.account-type"
            defaultMessage={`Account type: <strong>{accountType, select,
                personal {personal}
                student {student}
                youth {youth}
                other {senior}
                }</strong>`}
            values={{
                accountType: accountType,
                ...DefaultIntlFormatValues,
            }}
        />,

        // eslint-disable-next-line jsx-control-statements/jsx-use-if-tag
        eligibility
            ? (
                <FormattedMessage
                    key="a3"
                    id="web-components.chequing.footer.eligibility"
                    defaultMessage="Eligibility: <strong>see “{seeMoreText}”</strong>"
                    values={{
                        seeMoreText: intl.formatMessage(LOCAL_MESSAGES.showMore).toLowerCase(),
                        ...DefaultIntlFormatValues,
                    }}
                />
            )
            : undefined,
    ];
}

const LOCAL_MESSAGES = defineMessages({
    showMore: {
        // must match the 'other' part of the select in web-components.chequing-card.show-more
        id: 'web-components.chequing.footer.more-details',
        defaultMessage: 'More details',
    },
});


export default ChequingAccountFooter;
